export default __webpack_public_path__ + "static/media/company3.80ef5954.svg";